// Lightweight i18n translations for static UI labels.
// Languages: en (English), ar (Arabic), zh (Simplified Chinese), hi (Hindi), ru (Russian)

export const LANGUAGES = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "zh", label: "中文", dir: "ltr" },
  { code: "hi", label: "हिन्दी", dir: "ltr" },
  { code: "ru", label: "Русский", dir: "ltr" },
];

const dict = {
  en: {
    topbar_call: "Contact us",
    nav_offers: "Our Best Monthly Offers",
    nav_register: "Register",
    nav_draw: "Exclusive Draw",
    nav_maps: "Store Maps",
    nav_contact: "Contact us",
    departures_promo: "Departures Promotion",
    arrivals_promo: "Arrivals Promotion",
    all: "All",
    shop_map: "SHOP MAPS",
    win_with_ddf: "WIN WITH DDF",
    no_shop_map: "No Shop Map Uploaded",
    register_with_us: "REGISTER WITH US",
    register_subtitle: "Turn your duty-free shopping into a 5,000 Gift Card",
    register_cta: "Register Now",
    millennium: "Millennium Millionaire",
    millennium_sub: "Win US$ 1,000,000",
    finest_surprise: "Finest Surprise",
    win_luxury_car: "Win a Luxury Car",
    win_motorcycle: "Win a Motorcycle",
    follow_us: "Follow us",
    contact_title: "Contact Us",
    contact_phone: "Phone",
    contact_tollfree: "Toll Free",
    contact_email: "Email",
    close: "Close",
    price: "Price",
    was: "Was",
    valid_until: "Valid until 31 May 2026",
    in_aed: "AED",
    in_usd: "US$",
    no_items: "No items in this category.",
  },
  ar: {
    topbar_call: "اتصل بنا",
    nav_offers: "أفضل عروضنا الشهرية",
    nav_register: "تسجيل",
    nav_draw: "السحب الحصري",
    nav_maps: "خرائط المتجر",
    nav_contact: "اتصل بنا",
    departures_promo: "عروض المغادرة",
    arrivals_promo: "عروض الوصول",
    all: "الكل",
    shop_map: "خريطة المتجر",
    win_with_ddf: "اربح مع دبي ديوتي فري",
    no_shop_map: "لم يتم تحميل خريطة المتجر",
    register_with_us: "سجل معنا",
    register_subtitle: "حوّل تسوقك المعفي من الرسوم إلى بطاقة هدية بقيمة 5,000",
    register_cta: "سجل الآن",
    millennium: "ميلينيوم مليونير",
    millennium_sub: "اربح 1,000,000 دولار أمريكي",
    finest_surprise: "أرقى مفاجأة",
    win_luxury_car: "اربح سيارة فاخرة",
    win_motorcycle: "اربح دراجة نارية",
    follow_us: "تابعنا",
    contact_title: "اتصل بنا",
    contact_phone: "الهاتف",
    contact_tollfree: "الرقم المجاني",
    contact_email: "البريد الإلكتروني",
    close: "إغلاق",
    price: "السعر",
    was: "كان",
    valid_until: "صالح حتى 31 مايو 2026",
    in_aed: "درهم",
    in_usd: "دولار",
    no_items: "لا توجد عناصر في هذه الفئة.",
  },
  zh: {
    topbar_call: "联系我们",
    nav_offers: "本月最佳优惠",
    nav_register: "注册",
    nav_draw: "独家抽奖",
    nav_maps: "门店地图",
    nav_contact: "联系我们",
    departures_promo: "出境店内促销",
    arrivals_promo: "入境店内促销",
    all: "全部",
    shop_map: "门店地图",
    win_with_ddf: "赢在 DDF",
    no_shop_map: "尚未上传门店地图",
    register_with_us: "立即注册",
    register_subtitle: "将您的免税购物转化为价值 5,000 的礼品卡",
    register_cta: "立即注册",
    millennium: "千禧富翁抽奖",
    millennium_sub: "赢取 100 万美元",
    finest_surprise: "至尊惊喜",
    win_luxury_car: "赢取豪华汽车",
    win_motorcycle: "赢取摩托车",
    follow_us: "关注我们",
    contact_title: "联系我们",
    contact_phone: "电话",
    contact_tollfree: "免费电话",
    contact_email: "邮箱",
    close: "关闭",
    price: "价格",
    was: "原价",
    valid_until: "有效期至 2026 年 5 月 31 日",
    in_aed: "迪拉姆",
    in_usd: "美元",
    no_items: "该类别没有商品。",
  },
  hi: {
    topbar_call: "हमसे संपर्क करें",
    nav_offers: "हमारे बेहतरीन मासिक ऑफर",
    nav_register: "रजिस्टर करें",
    nav_draw: "एक्सक्लूसिव ड्रॉ",
    nav_maps: "स्टोर मानचित्र",
    nav_contact: "संपर्क करें",
    departures_promo: "प्रस्थान प्रोमोशन",
    arrivals_promo: "आगमन प्रोमोशन",
    all: "सभी",
    shop_map: "स्टोर मानचित्र",
    win_with_ddf: "DDF के साथ जीतें",
    no_shop_map: "कोई मानचित्र अपलोड नहीं किया गया",
    register_with_us: "हमारे साथ रजिस्टर करें",
    register_subtitle: "अपनी ड्यूटी-फ्री खरीदारी को 5,000 गिफ्ट कार्ड में बदलें",
    register_cta: "अभी रजिस्टर करें",
    millennium: "मिलेनियम मिलियनेयर",
    millennium_sub: "US$ 1,000,000 जीतें",
    finest_surprise: "बेहतरीन सरप्राइज़",
    win_luxury_car: "एक लक्ज़री कार जीतें",
    win_motorcycle: "एक मोटरसाइकिल जीतें",
    follow_us: "हमें फॉलो करें",
    contact_title: "हमसे संपर्क करें",
    contact_phone: "फ़ोन",
    contact_tollfree: "टोल फ्री",
    contact_email: "ईमेल",
    close: "बंद करें",
    price: "कीमत",
    was: "पहले",
    valid_until: "31 मई 2026 तक मान्य",
    in_aed: "AED",
    in_usd: "US$",
    no_items: "इस श्रेणी में कोई आइटम नहीं है।",
  },
  ru: {
    topbar_call: "Свяжитесь с нами",
    nav_offers: "Наши лучшие ежемесячные предложения",
    nav_register: "Регистрация",
    nav_draw: "Эксклюзивный розыгрыш",
    nav_maps: "Карты магазинов",
    nav_contact: "Контакты",
    departures_promo: "Акции для вылетающих",
    arrivals_promo: "Акции для прилетающих",
    all: "Все",
    shop_map: "КАРТА МАГАЗИНА",
    win_with_ddf: "ВЫИГРАЙ С DDF",
    no_shop_map: "Карта магазина не загружена",
    register_with_us: "ЗАРЕГИСТРИРУЙТЕСЬ У НАС",
    register_subtitle:
      "Превратите свои покупки duty-free в подарочную карту на 5 000",
    register_cta: "Зарегистрироваться",
    millennium: "Миллениум Миллионер",
    millennium_sub: "Выиграйте 1 000 000 долларов США",
    finest_surprise: "Утончённый сюрприз",
    win_luxury_car: "Выиграйте роскошный автомобиль",
    win_motorcycle: "Выиграйте мотоцикл",
    follow_us: "Подписывайтесь",
    contact_title: "Свяжитесь с нами",
    contact_phone: "Телефон",
    contact_tollfree: "Бесплатный номер",
    contact_email: "Эл. почта",
    close: "Закрыть",
    price: "Цена",
    was: "Было",
    valid_until: "Действует до 31 мая 2026",
    in_aed: "AED",
    in_usd: "US$",
    no_items: "В этой категории нет товаров.",
  },
};

// --- Google-style live machine translation via backend LLM proxy -------------
// MT results override the static dictionary; static remains a resilient fallback.
const mtCache = {}; // { lang: { key: translated } }

function loadMTFromStorage(lang) {
  if (mtCache[lang]) return true;
  try {
    const raw = localStorage.getItem(`ddf_mt_${lang}`);
    if (raw) {
      mtCache[lang] = JSON.parse(raw);
      return true;
    }
  } catch (e) {
    /* ignore */
  }
  return false;
}

// Fetch translations for every UI string for `lang`. Resolves true if the MT
// cache changed (so the caller can trigger a re-render).
export async function ensureTranslations(lang) {
  if (!lang || lang === "en") return false;
  if (mtCache[lang]) return false;
  if (loadMTFromStorage(lang)) return true;
  const base = process.env.REACT_APP_BACKEND_URL;
  try {
    const res = await fetch(`${base}/api/i18n/translate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ target: lang, strings: dict.en }),
    });
    if (!res.ok) return false;
    const data = await res.json();
    mtCache[lang] = data.translations || {};
    try {
      localStorage.setItem(`ddf_mt_${lang}`, JSON.stringify(mtCache[lang]));
    } catch (e) {
      /* ignore quota */
    }
    return true;
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("MT load failed", e);
    return false;
  }
}

export function t(lang, key) {
  const mt = mtCache[lang] && mtCache[lang][key];
  if (mt) return mt;
  return (dict[lang] && dict[lang][key]) || dict.en[key] || key;
}
